import { render } from "./PreviousStep.vue?vue&type=template&id=b64d588e"
import script from "./PreviousStep.vue?vue&type=script&lang=js"
export * from "./PreviousStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__